import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialPaginationModel } from "../../constants/variables";
import { useAppSelector } from "../hooks";

const productSlice = createSlice({
  name: "product",
  initialState: initialPaginationModel,
  reducers: {
    setProductPaginationModel: (
      state,
      action: PayloadAction<PaginationModel>
    ) => {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
    },
    resetProductState: () => initialPaginationModel,
  },
});

export const { setProductPaginationModel, resetProductState } = productSlice.actions;

export default productSlice.reducer;

export const useProductPaginationModel = () =>
  useAppSelector((state) => state.product);
